<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <div class="mb25 s_flex_bian_c">
        <span class='mr15'>
          <a-button type="primary" v-has:orderLogisticsCreate="()=>openAdd(0)">
            <PlusOutlined />
            添加物流公司
          </a-button>
        </span>
      </div>
      <a-form ref='forms' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search"
        :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="关键词" name='keyword'>
          <a-input v-model:value="search.keyword" style="width:300px" placeholder="请输入物流公司名称或者编码" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
        <template v-slot:is_show="{ record }">
          <a-switch :checkedValue="1" :unCheckedValue="0" checked-children="显示" un-checked-children="隐藏" v-model:checked="record.is_show"
            @change="expressState(record)" />
        </template>
        <template v-slot:action="{ record }">
          <a-button v-has:orderLogisticsEdit="()=>openAdd(record)" type="primary" class="m-r-10">编辑</a-button>
          <a-button v-has:orderLogisticsDel="()=>expressDel(record)" danger>删除</a-button>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
        :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
        @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
    </a-card>
  </a-layout>
  <a-modal  :keyboard="false" :title="form.id ? '编辑物流公司':'添加物流公司'" centered :footer="null" v-model:visible="visible" destroyOnClose>
    <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item  ref="name" label="公司名称" name="name">
        <div class='s_flex_bian_c'>
          <a-input class="width80" v-model:value="form.name" readonly placeholder='选择物流公司名称' />
          <a-button type="primary" @click="showExpress=true">选择</a-button>
        </div>
      </a-form-item>
      <a-form-item ref="sort" label="排序" name="sort">
        <a-input-number class="width100" v-model:value="form.sort" :min='0' :precision='0' placeholder='请输入排序' />
      </a-form-item>
      <a-form-item ref="is_show" label="状态" name="is_show">
        <a-radio-group v-model:value="form.is_show" @change="onChange">
          <a-radio :value="1">显示</a-radio>
          <a-radio :value="0">隐藏</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 4, offset: 4 }">
        <a-button type="primary" @click="onSubmit">
          保存
        </a-button>
      </a-form-item>
    </a-form>
  </a-modal>
  <a-modal  :keyboard="false" title="选择物流公司" centered :footer="null" :width='1300' v-model:visible="showExpress" destroyOnClose>
    <Express @select='select' :selectList='selectList'></Express>
  </a-modal>
</template>
<script>
  import { PlusOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getExpressList, setExpressAdd, setExpressEdit, setExpressState, setExpressDel, getExpressMore } from "@/api/order";
  import { iscode } from "@/utils/app";
  import Express from './components/list';
  // 初始化默认筛选项数值
  let defSearch = {
    keyword: '',
    page: 1,
    limit: 10,
  };
  let defForm = {
    lib_express_id: '',
    sort: '',
    is_show: 1
  }
  export default {
    components: { PlusOutlined, Express },
    setup(props, ctx) {
      // // 初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      const form = ref({ ...defForm });
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        showExpress:false,
        listLoading: false,
        selectList:[],
        total: 1,
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
        visible: false,
        rules: {
          name: [
            { required: true, message: '请选择物流公司', },
          ]
        }
      });
      let columns = [
        {
          title: "ID",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "物流公司名称",
          dataIndex: "name",
          key: "name",
        },
        {
          title: '编码',
          dataIndex: "code",
          key: "code",
        },
        {
          title: '排序',
          dataIndex: "sort",
          key: "sort",
        },
        {
          title: "是否显示",
          key: "is_show",
          slots: { customRender: "is_show" },
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        },
      ];
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      const _lodash = inject("_lodash");
      const ruleForm = ref()

      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      //改变状态
      const expressState = async (e) => {
        let res = await setExpressState({ id: e.id }).then(res => res.data);
      }
      //删除
      const expressDel = async (e) => {
        $Modal.confirm({
          centered: true,
          title: '物流公司删除',
          content: '删除后该物流公司将无法恢复，您确定要删除该物流公司吗？', onOk: async () => {
            let res = await setExpressDel({ id: e.id }).then(res => res.data);
            if (iscode(res)) {
              message.success(res.msg);
              initData(search.value);
            } else {
              message.error(res.msg);
            }
          }
        })
      }
      //打开添加
      const openAdd = async (e) => {
        if (e == 0) {
          form.value = {}
          state.visible = true
        } else {
          let res = await getExpressMore(e.id).then(res => res.data);
          if (iscode(res)) {
            form.value = res.data
            state.visible = true
          } else {
            message.error(res.msg);
          }

        }
      }
      //选择物流公司
      const select = (e) =>{
        state.selectList = [e]
        form.value.lib_express_id = e.id
        form.value.name = e.name
        state.showExpress = false
      }
      //提交
      const onSubmit = () => {
        ruleForm.value.validate().then(async () => {
          let res
          const hide = message.loading('正在加载中...', 0);
          if (form.value.id) {
            res = await setExpressEdit(form.value).then(res => res.data);
          } else {
            res = await setExpressAdd(form.value).then(res => res.data);
          }
          if (iscode(res)) {
            message.success(res.msg);
            state.visible = false
            setTimeout(hide);
            setTimeout(() => {
              initData(search.value);
            }, 2000);
          } else {
            message.error(res.msg);
            setTimeout(hide);
          }
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      //获取列表
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await getExpressList(values).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data.data;
            state.total = res.data.total;
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };
      onMounted(() => {
        initData(search.value);
      });
      return {
        ...toRefs(state),
        form,
        ruleForm,
        search,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        expressState,
        onSubmit,
        openAdd,
        expressDel,
        select
      };
    },
  };
</script>